export class WeChatMessageTemplateDto {
    keyId: string = '';
    id: string = '';
    applicationId: string = '';
    code: string = '';
    name: string = '';
    templateId: string = '';
    templateTitle: string = '';
    templateKeyword1: string = '';
    templateKeyword2: string = '';
    templateKeyword3: string = '';
    templateKeyword4: string = '';
    templateKeyword5: string = '';
    pageUrl: string = '';
    remarks: string = '';
}